import raw from "raw.macro";
const datepickerCSS = raw("react-datepicker/dist/react-datepicker.css");
const reactImageLightboxCSS = raw("react-image-lightbox/style.css");

const globalStyles = `
  body {
    background: #f9f9f9 !important;
  }

  ${datepickerCSS}
  ${reactImageLightboxCSS}
`;

export default globalStyles;
